import { postDetails } from "../../../services/Admin/http/http.services"
import { ApiPaths } from "../../../utils/Admin/constants/api-path.constants"
import { handleTokenState } from "../authentication/authentication.slice"
import { onReportsFailure, onReportsInit, onReportsSuccess, onGettingFilterOptions } from "./reports.slice"

export const getVendors = () => {
    return async (dispatch) => {
        try {
            dispatch(onReportsInit(''))
            const result = await postDetails(ApiPaths.DROPDOWN_DATA_URL, {})
            if (result === 401) {
                dispatch(handleTokenState(true))
            }

            if (typeof result !== 'undefined') {
                console.log(result)
                dispatch(onGettingFilterOptions(result))
            } else {
                dispatch(onReportsFailure({errorCode: 0, empty: false}))
            }
        } catch (error) {
            console.log(error);
            dispatch(onReportsFailure({errorCode: 2, empty: false}))
        }
    }
}

export const getReports = (filtersPayload) => {
    return async(dispatch) => {
        dispatch(onReportsInit({ vendorName: filtersPayload.BROKER_NAME }))
        try {
            const result = await postDetails(ApiPaths.REPORTS_URL, filtersPayload)
            if (result === 401) {
                dispatch(handleTokenState(true))
                return
            }

            if (typeof result.DETAILS !== 'undefined') {
                if (result.DETAILS.length === 0) {
                    dispatch(onReportsFailure({errorCode: 0, empty: true}))
                    return
                }
                dispatch(onReportsSuccess(result.DETAILS))
                return
            }

            dispatch(onReportsFailure({errorCode: 1, empty: false}))

        } catch (error) {
            console.log(error);
            dispatch(onReportsFailure({errorCode: 2, empty: false}))
        }
    }
}